import _ from 'lodash';
import {t} from '../../../../../../services/i18n';
import {sortString} from '../../../../../../services/Helpers';

export const ONLY_AVAILABLE_KEY = 'only_available';
export const ALL_KEY = 'all';
export const ALL_LOCATIONS_KEY = 'all_locations';
export const ALL_CATEGORY_GROUPS_KEY = 'all_category_groups';
export const ALL_HUG_TYPES_KEY = 'all_hug_types';
export const ALL_STAFF_KEY = 'all_staff';

export const getHugFiltersConfig = ({ showCategoryGroupFilter, isMultiLocation, locationOptions, canceledCourseLocation }) => [
    {
        key: 'categoryGroup',
        show: showCategoryGroupFilter,
        defaultValue: ALL_CATEGORY_GROUPS_KEY,
        options: (baseList) => {
            const groups = baseList.map(h => h.box_categories?.box_categories_groups?.[0]).filter(Boolean);
            const unique = _.uniqBy(groups, 'id');
            return [
                { value: ALL_CATEGORY_GROUPS_KEY, label: t('all-category-types') },
                ..._.sortBy(unique, g => sortString(g.name)).map(g => ({ value: g.id, label: g.name })),
            ];
        },
        filterFunc: (hug, value) => !value || value === ALL_CATEGORY_GROUPS_KEY || hug.box_categories?.box_categories_groups?.[0]?.id === value,
        style: { minWidth: '160px', flex: 1 },
    },
    {
        key: 'hugType',
        show: true,
        defaultValue: ALL_HUG_TYPES_KEY,
        options: (baseList) => {
            const cats = baseList.map(h => h.box_categories).filter(Boolean);
            const unique = _.uniqBy(cats, 'id');
            return [
                { value: ALL_HUG_TYPES_KEY, label: t('all-hugim-types') },
                ..._.sortBy(unique, c => sortString(c.name)).map(c => ({ value: c.id, label: c.name })),
            ];
        },
        filterFunc: (hug, value) => !value || value === ALL_HUG_TYPES_KEY || hug.box_categories?.id === value,
        style: { minWidth: '160px', flex: 1 },
    },
    {
        key: 'staff',
        show: true,
        defaultValue: ALL_STAFF_KEY,
        options: (baseList) => {
            const coaches = [
                ...baseList.map(h => h.coach).filter(Boolean),
                ...baseList.map(h => h.second_coach).filter(Boolean),
            ];
            const unique = _.uniqBy(coaches, 'id');
            return [
                { value: ALL_STAFF_KEY, label: t('all-staff-members') },
                ..._.sortBy(unique, c => sortString(`${c.first_name} ${c.last_name}`))
                    .map(c => ({ value: c.id, label: `${c.first_name} ${c.last_name || ''}` })),
            ];
        },
        filterFunc: (hug, value) => !value || value === ALL_STAFF_KEY || hug.coach?.id === value || hug.second_coach?.id === value,
        style: { minWidth: '160px', flex: 1 },
    },
    {
        key: 'availability',
        show: true,
        defaultValue: ONLY_AVAILABLE_KEY,
        options: [
            { value: ONLY_AVAILABLE_KEY, label: t('only-available-hugim') },
            { value: ALL_KEY, label: t('all-hugim') },
        ],
        filterFunc: (hug, value) => value !== ONLY_AVAILABLE_KEY || !hug.isHugFull,
        style: { minWidth: '180px', flex: 1 },
    },
    {
        key: 'location',
        show: isMultiLocation,
        defaultValue: canceledCourseLocation?.id ?? ALL_LOCATIONS_KEY,
        options: locationOptions,
        filterFunc: (hug, value) => !value || value === ALL_LOCATIONS_KEY || (hug.locations_box_fk ?? hug.location_fk) === value,
        style: { minWidth: '160px', flex: 1 },
    },
];
